import React from 'react';
import { Drawer, type DrawerProps } from '@mui/material';
import { cs } from '@bbkAdminUtils/css-utils';
import { type BaseCSSProperties } from '@mui/material/styles/createMixins';

type Props = DrawerProps & {
  // add more styles that you want to support
  // trying to limit
  drawerStyles?: Pick<
    BaseCSSProperties,
    'overflow' | 'position' | 'height' | 'width' | 'backgroundColor'
  >;
  anchor?: 'left' | 'right' | 'top' | 'bottom';
  disablePortal?: boolean;
  hideBackdrop?: boolean;
};

export const EditorDrawer: React.FC<Props> = ({
  open,
  onClose,
  drawerStyles = {},
  anchor,
  disablePortal = false,
  hideBackdrop = false,
  ...restProps
}) => {
  const resolvedAnchor = anchor ?? 'bottom';
  return (
    <Drawer
      open={open}
      anchor={resolvedAnchor}
      PaperProps={{
        className: cs('!tw-h-screen tw-bg-[#F6F8FB]', {
          '!tw-w-screen': resolvedAnchor === 'bottom',
        }),
        style: drawerStyles,
      }}
      ModalProps={{
        ...(disablePortal && {
          disablePortal: true,
        }),
        ...(hideBackdrop && {
          hideBackdrop: true,
        }),
      }}
      sx={{
        ...(disablePortal && {
          position: 'absolute',
          height: '100%',
          width: '100%',
          '& .MuiDrawer-paper': {
            position: 'absolute',
            height: '100%',
            width: '100%',
            maxWidth: '100%',
          },
        }),
      }}
      onClose={onClose}
      {...restProps}
    />
  );
};
